// extracted by mini-css-extract-plugin
module.exports = {"labelField":"index-module__labelField___yNSZv","iconDelete":"index-module__iconDelete___ZcLAQ"};